import { GET_REFERENCE_ROUTE_REQUESTED } from "../types/types";

export const getReferenceRoutes =  (queryParams) => ({
    type: GET_REFERENCE_ROUTE_REQUESTED,
    payload: { queryParams }
});